import { useSelector } from "react-redux";
import { _ } from "src/services";
import { Packages } from "src/store";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";


export const PaymentGateway: React.FC<{ bank: number, setBank: (x: number) => void }> = ({ bank, setBank }) => {

    //#region dependencies

    const packages: Packages = useSelector((state: any) => state.PackagesState);

    //#endregion

    //#region helpers

    const renderContent = () => {
        if (packages.loading && !packages.order) return (
            <>
                <div className="payment-box__gateway-item mx-2 shimmer">
                    <img alt="" src={phPackage} />
                </div>
                <div className="payment-box__gateway-item mx-2 shimmer">
                    <img alt="" src={phPackage} />
                </div>
                <div className="payment-box__gateway-item mx-2 shimmer">
                    <img alt="" src={phPackage} />
                </div>
            </>
        );

        return (
            <>
                {packages.order?.banks?.map((x, index) => (
                    <div
                        key={index}
                        className={`payment-box__gateway-item mx-4${x.type === bank ? " active" : ""}`}
                        onClick={() => setBank(x.type)}>
                        <img alt={x.title} src={x.logo} />
                    </div>
                ))
                }
            </>
        );
    };

    //#endregion

    return (
        <div className="payment-bill-info d-flex flex-column mb-4">
            <div className="payment-box__title text-md-center py-2">{_("selectGatewayTitle")}</div>
            <div className="payment-box__gateway-container d-flex justify-content-center mt-4">
                {renderContent()}
            </div>
        </div>
    );

};